const DEFAULT_PHRASES = [
  "Motherhood Is Leadership™",
  "Systems Create Freedom",
  "Success Without Sacrifice",
  "You Don't Have to Choose",
];

export const Marquee = ({ phrases = DEFAULT_PHRASES }) => {
  // One wide unit (doubled) so the -50% loop stays seamless on any screen width
  const unit = [...phrases, ...phrases];
  const sequence = [...unit, ...unit];
  return (
    <div className="w-full overflow-hidden border-y border-gold/30 bg-cream py-5 select-none" data-testid="editorial-marquee">
      <div className="animate-marquee">
        {sequence.map((p, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-sans uppercase tracking-[0.35em] text-sm md:text-base font-medium text-terracotta/70 px-8">
              {p}
            </span>
            <span className="font-serif italic text-lg text-gold px-2">&amp;</span>
          </span>
        ))}
      </div>
    </div>
  );
};
